// extracted by mini-css-extract-plugin
export default {"container":"PopupDownShortcut_container__wHZnp","content":"PopupDownShortcut_content__JCxFg","title":"PopupDownShortcut_title__K2n25"};